import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import Button from '@material-ui/core/Button';

class NotifList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datatable: this.props.datatable
    };
  }

  getUserLevel = userlevel => {
    let user_level;
    switch (userlevel) {
      case 0:
        user_level = "Programmer";
        break;
      case -1:
        user_level = "All";
        break;
      case 2:
        user_level = "Administrator";
        break;
      case 3:
        user_level = "Guest";
        break;
    }

    return user_level;
  };

  render() {
    const columns = [
      {
        name: "id",
        label: "id",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "company_code",
        label: "Company Code",
        options: {
          filter: true
        }
      },
      {
        name: "title",
        label: "Title",
        options: {
          filter: true
        }
      },
      {
        label: "Description",
        name: "description",
        options: {
          filter: false
        }
      },
      {
        label: "User Level",
        name: "userlevel",
        options: {
          filter: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return this.getUserLevel(value);
          }
        }
      },
      {
        label: "Date",
        name: "date",
        options: {
          filter: true
        }
      },
      {
        name: "Action",
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            let id = (tableMeta.rowData !== undefined) ? tableMeta.rowData[0]:0
            return (
              <div>
                <Button variant="outlined" color="secondary" onClick={() => this.props.handleDelete(id)}>
                  Delete
                </Button>
                <Button variant="outlined" color="primary" onClick={()=>this.props.restate(tableMeta.rowData)} >
                  Update
                </Button>
              </div>
            );
          }
        }
      }
    ];

    const options = {
      filter: false,
      //filterType: "dropdown",
      selectableRows: false,
      responsive: "scroll",
      textLabels: {
        body: {
          noMatch: this.props.loader ? "Searching..." : "Sorry, no matching records found"
        }
      }
    };

    return (
      <MUIDataTable
        title={"Alert"}
        data={this.props.datatable}
        columns={columns}
        options={options}
      />
    );
  }
}

export default NotifList;
